import PropTypes from 'prop-types';
import "components/ui/Button/Button.scss";

function Button({ children, onClick, variant, className }) {
  return (
      <button onClick={ () => onClick() }
              className={ `button button--${ variant ? variant : 'primary' } ${ className || '' }` }>
        { children }
      </button>
  )
}

Button.propTypes = {
  onClick: PropTypes.func,
  variant: PropTypes.string,
  cssClass: PropTypes.string,
}

export default Button;
